import { MainLink } from "../../components/V2/Navigation/NavHeading"

import { getUrlFromStoryblokLink, linkIsNotNull } from "@utils/storyblok"

/**
 * Map storyblok TopNavigation main links object array to the format
 * accepted by the Navigation component
 */
export const mapTopNavigationMainLinks = (
  mainLinks: Storyblok.TopNavigationMainLink[]
): MainLink[] => {
  return mainLinks.map((mainLink) => ({
    label: mainLink.label,
    link:
      mainLink.link && linkIsNotNull(mainLink.link)
        ? getUrlFromStoryblokLink(mainLink.link)
        : undefined,
    queryParams: mainLink.queryParams,
    subMenu:
      mainLink.type === "subMenu" && mainLink.subMenu?.[0]
        ? {
            title: mainLink.subMenu[0].title,
            content: mainLink.subMenu[0].content.map((contentItem) => ({
              label: contentItem.label,
              menuContent: contentItem.menuContent
                .map((menuBlock) => {
                  if (menuBlock.type === "display") {
                    if (!menuBlock.link?.[0]) {
                      return null
                    }
                    return {
                      type: menuBlock.type,
                      title: menuBlock.title,
                      hoverZoom: menuBlock.hoverZoom,
                      link: {
                        label: menuBlock.link[0].label,
                        description: menuBlock.link[0].description,
                        link: getUrlFromStoryblokLink(menuBlock.link[0].link),
                        image: menuBlock.link[0].image?.filename,
                        imageSize: menuBlock.link[0].imageSize,
                        queryParams: menuBlock.link[0].queryParams,
                      },
                    }
                  } else {
                    if (!menuBlock.links?.length) {
                      return null
                    }
                    return {
                      type: menuBlock.type,
                      title: menuBlock.title,
                      links: menuBlock.links.map((link) => ({
                        label: link.label,
                        description: link.description,
                        link: getUrlFromStoryblokLink(link.link),
                        image: link.image?.filename,
                        imageSize: link.imageSize,
                        queryParams: link.queryParams,
                      })),
                      ctaText: menuBlock.ctaText,
                      ctaLink: menuBlock.ctaLink
                        ? getUrlFromStoryblokLink(menuBlock.ctaLink)
                        : undefined,
                      queryParams: menuBlock.queryParams,
                    }
                  }
                })
                .filter(
                  (item): item is NonNullable<typeof item> => item !== null
                ),
            })),
          }
        : undefined,
    menuColumnBlocks:
      mainLink.type === "content" && mainLink.content?.length
        ? mainLink.content.map((contentItem) => ({
            type: "link",
            title: contentItem.title,
            links: contentItem.links.map((link) => ({
              label: link.label,
              description: link.description,
              link: getUrlFromStoryblokLink(link.link),
              queryParams: link.queryParams,
            })),
          }))
        : undefined,
  }))
}
